import React from "react";
import { BsArrowRightShort } from "react-icons/bs";
import { Link } from "react-router-dom";

const ShowAllLink = ({ text, to }) => {
  return (
    <Link to={to}>
      <div className="group flex items-center">
        <span>{text}</span>
        <span className="text-3xl transition-all duration-300 group-hover:translate-x-2">
          <BsArrowRightShort />
        </span>
      </div>
    </Link>
  );
};

export default ShowAllLink;
